import React, { useState } from 'react';
import styled from 'styled-components';
import { FaPlus, FaMinus } from 'react-icons/fa';

const faqData = [
    {
        category: 'General',
        questions: [
            {
                q: 'What is The Letter Doctor?',
                a: 'The Letter Doctor is a private medical service providing a range of medical letters, certificates, and referral letters. Our services are provided by experienced, UK-based doctors who are all registered with the General Medical Council (GMC).',
            },
            {
                q: 'Who are The Letter Doctor doctors?',
                a: 'All our doctors are UK-based, GMC-registered, and have extensive experience in the NHS and private practice. They adhere to the highest standards of medical care and confidentiality.',
            },
            {
                q: 'What services do you provide?',
                a: 'We provide a wide range of medical documents, including sickness letters for work or university, travel and holiday certificates (like Fit to Fly), visa medicals, recovery certificates, and private referral letters to specialists.',
            },
            {
                q: 'How does it work?',
                a: 'Simply select the service you need, fill out a short online questionnaire, and submit your request. One of our doctors will review your information and, if appropriate, issue your medical letter or certificate, usually on the same day.',
            },
            {
                q: 'Is my data safe?',
                a: 'Absolutely. We are fully compliant with GDPR and all data protection regulations. Your personal and medical information is stored securely and is strictly confidential.',
            },
        ],
    },
    {
        category: 'Medical Letters & Certificates',
        questions: [
            {
                q: 'How quickly will I receive my letter?',
                a: 'We pride ourselves on a fast turnaround. Most letters and certificates are reviewed and delivered to your email inbox on the same day you submit your request.',
            },
            {
                q: 'How much do your services cost?',
                a: 'Our prices are clearly listed on each service page. There are no hidden fees. You pay for the service you select.',
            },
            {
                q: 'Will my letter or certificate be accepted?',
                a: 'Our letters are issued by GMC-registered doctors and are widely accepted by employers, universities, airlines, and other institutions. We have a very high acceptance rate. However, we always recommend checking with the specific institution if they have any unique requirements.',
            },
            {
                q: 'Can I request a letter for someone else?',
                a: 'You can request a letter for a child under your care. For adults, the individual requiring the letter must complete the questionnaire themselves to ensure medical accuracy and consent.',
            },
        ],
    },
    {
        category: 'Payments & Refunds',
        questions: [
            {
                q: 'What payment methods do you accept?',
                a: 'We accept all major credit and debit cards, including Visa and Mastercard, as well as payments via PayPal, Apple Pay, and Google Pay.',
            },
            {
                q: 'Can I get a refund?',
                a: 'If our doctor determines that we are unable to provide the letter or certificate you have requested, you will receive a full refund. If a letter has been issued, we are unable to offer a refund.',
            },
        ],
    },
];

const FaqPageContainer = styled.div`
  max-width: 900px;
  margin: 4rem auto;
  padding: 0 2rem;
`;

const PageTitle = styled.h1`
  font-size: 2.8rem;
  text-align: center;
  margin-bottom: 3rem;
  color: #333;
`;

const CategorySection = styled.div`
  margin-bottom: 3rem;
`;

const CategoryTitle = styled.h2`
  font-size: 1.8rem;
  color: #005eb8;
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e0e0e0;
`;

const FaqItem = styled.div`
  border-bottom: 1px solid #e0e0e0;
  padding: 1.5rem 0;

  &:last-child {
    border-bottom: none;
  }
`;

const QuestionButton = styled.button`
  width: 100%;
  background: none;
  border: none;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
  cursor: pointer;
  padding: 0;

  &:hover {
    color: #005eb8;
  }
`;

const Answer = styled.div`
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-out, padding-top 0.3s ease-out;
  color: #555;
  line-height: 1.7;
  font-size: 1rem;

  &.open {
    max-height: 500px; /* Adjust as needed */
    padding-top: 1rem;
    transition: max-height 0.5s ease-in, padding-top 0.5s ease-in;
  }
`;

const Faq = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFaq = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <FaqPageContainer>
            <PageTitle>Frequently Asked Questions</PageTitle>
            {faqData.map((category, catIndex) => (
                <CategorySection key={catIndex}>
                    <CategoryTitle>{category.category}</CategoryTitle>
                    {category.questions.map((item, qIndex) => (
                        <FaqItem key={`${catIndex}-${qIndex}`}>
                            <QuestionButton onClick={() => toggleFaq(`${catIndex}-${qIndex}`)}>
                                <span>{item.q}</span>
                                {openIndex === `${catIndex}-${qIndex}` ? <FaMinus /> : <FaPlus />}
                            </QuestionButton>
                            <Answer className={openIndex === `${catIndex}-${qIndex}` ? 'open' : ''}>
                                <p>{item.a}</p>
                            </Answer>
                        </FaqItem>
                    ))}
                </CategorySection>
            ))}
        </FaqPageContainer>
    );
};

export default Faq;